import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { faFileImage, faTableCells } from "@fortawesome/free-solid-svg-icons";
import { gridColor, iconSize } from "../../App/GridRenderers";

export const GridChartIcon = ({ onClick }) => {
    return (
        <Box sx={{ pt: 1 }}>
            <FontAwesomeIcon
                color={gridColor}
                size={iconSize}
                icon={faTableCells}
                onClick={() => { onClick(true) }}
            />
        </Box>
    );
};

export const ChartIcon = ({ onClick }) => {
    return (
        <Box sx={{ pt: 1 }}>
            <FontAwesomeIcon
                color={gridColor}
                size={iconSize}
                icon={faFileImage}
                onClick={() => { onClick(true) }}
            />
        </Box>
    );
};


